interface CommonOptions {
  item    : any,
  newLine?: string,
  mapping?: any,
}

const getDoiURL = (item: any) =>
  item.ext_ids.doi
    ? "http://dx.doi.org/" + item.ext_ids.doi
    : ""

const getPubmedURL = (item: any) =>
  item.ext_ids.pmid
    ? "http://www.ncbi.nlm.nih.gov/pubmed/" + item.ext_ids.pmid
    : ""

function formatAuthor(author: string) {

  const parts =
    author
      ?.split(" ")
      ?.filter(s => s)

  if (!parts || !parts.length)
    return ""

  if (parts.length === 1)
    return parts[0]

  const lastName =
    parts
      .pop()
      ?.trim()

  const names =
    parts
      .join(" ")
      .trim()

  const formattedAuthor = lastName + ", " + names

  return formattedAuthor
}

const getNewLine = (newLine: string | undefined) =>
  newLine || "\r\n"

const getYearMonth = (date: string) => {
  if (!/^\d+-\d+-\d+/.test(date))
    return { year: null, month: null }

  const yearMatch = /^\d+/.exec(date)
  const year = yearMatch && yearMatch[0]

  const monthMatch = /^\d+-(\d+)/.exec(date)
  const month = monthMatch && monthMatch[1]

  return { year, month }
}

const removeEmpty = (out: any) =>
  Object.entries(out)
    .filter(([key, value]) => value !== "" && value !== null && typeof value !== "undefined")
    .reduce((acc: any, entry) => {
      const [key, value] = entry
      acc[key] = value
      return acc
    }, {})

const onFile = (item: any, cb: (path: string) => any) => {
  const hasFiles = item.files && item.files.length
  if (!hasFiles)
    return

  const primaryWithPath = item.files
    .find((f: any) => f.type === "article" && f.localPath)
  if (!primaryWithPath)
    return

  const localhostPrefix = process.platform === "win32"
    ? "file://localhost/"
    : "file://localhost"

  const path = localhostPrefix + primaryWithPath.localPath.replace(/ /g, "%20")
  cb(path)
}

export {
  getDoiURL,
  getPubmedURL,
  formatAuthor,
  CommonOptions,
  getNewLine,
  getYearMonth,
  removeEmpty,
  onFile,
}
